Bingo.ResponsiveTabs = {};

Bingo.ResponsiveTabs.init = function (selector) {
    const initSlide = $(`${selector} .js-tabsSwiper__wrapper li`).index($(`${selector} .js-tabsSwiper__wrapper li:has(a.-active)`));

    // init swiper
    const swiperTabs = new Swiper(selector, {
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: initSlide,
        watchOverflow: true,
        resistanceRatio: 0.85,
        slideClass: 'js-tabsSwiper__slide',
        wrapperClass: 'js-tabsSwiper__wrapper',
        breakpoints: {
            992: {
                resistanceRatio: 0,
            },
        },
        init: false,
    });

    swiperTabs.on('init', () => {
        if (!swiperTabs.isBeginning) {
            $(selector).addClass('before-grad');
        }
        if (!swiperTabs.isEnd) {
            $(selector).addClass('after-grad');
        }
    });
    swiperTabs.init();

    // FF + IE11 swiper in modal bug workaround
    const modalWithSwiper = $(selector).closest('.modal');
    if ($(modalWithSwiper).length) {
        $(modalWithSwiper).on('shown.bs.modal', () => {
            if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                const evt = document.createEvent('UIEvents');
                evt.initUIEvent('resize', true, false, window, 0);
                window.dispatchEvent(evt);
            } else {
                window.dispatchEvent(new Event('resize'));
            }
        });
    }

    swiperTabs.on('reachBeginning', () => {
        $(selector).removeClass('before-grad');
    });
    swiperTabs.on('reachEnd', () => {
        $(selector).removeClass('after-grad');
    });
    swiperTabs.on('sliderMove', () => {
        if (!swiperTabs.isBeginning) {
            $(`${selector}:not(before-grad)`).addClass('before-grad');
        }
        if (!swiperTabs.isEnd) {
            $(`${selector}:not(after-grad)`).addClass('after-grad');
        }
    });
};
